<template>
  <modal ref="approveModal" sheet-class="ct-sheet">
    <template #header>
      <div class="apv-head">
        <span class="apv-head__ico"><i class="fas fa-paper-plane"></i></span>
        <div class="apv-head__text">
          <h4 class="modal-title apv-head__title">{{ ui.erp_submit_approval || 'ยืนยันการส่งอนุมัติ' }}</h4>
          <div class="apv-head__sub">{{ selectedFormName || 'เลือกฟอร์มอนุมัติเพื่อดูรายชื่อผู้อนุมัติ' }}</div>
        </div>
      </div>
    </template>
    <template #body>
      <div class="apv" :class="{ 'apv--split': isMango }">
        <section class="apv-pane apv-pane--forms">
        <div class="apv-step">
          <span class="apv-step__no">1</span>
          <span class="apv-step__label">
            Form Approve <span class="apv-req">*</span>
          </span>
          <span class="apv-count" v-if="isMango && (approveFormOptions || []).length">{{ (approveFormOptions || []).length }}</span>
        </div>
        <div class="apv-field" v-if="!isMango">
          <vue-select-2 :options="approveFormOptions"
                        :settings="{theme: 'bootstrap', selectionCssClass: 'form-control input-sm', placeholder: '-- Select Form Approve --', allowClear: true}"
                        v-model="localApproveFormCode">
          </vue-select-2>
        </div>
        <template v-else>
          <div class="apv-search">
            <i class="fas fa-search"></i>
            <input type="text" class="apv-search__input" v-model="formSearch" placeholder="ค้นหา Form Approve...">
            <a href="#" class="apv-search__clear" v-if="formSearch" @click.prevent="formSearch = ''"><i class="fas fa-times"></i></a>
          </div>
          <div class="apv-forms">
            <div class="apv-group" v-for="g in formGroups" :key="g.name">
              <div class="apv-group__title">
                <span>{{ g.name }}</span>
                <span class="apv-group__n">{{ g.items.length }}</span>
              </div>
              <button type="button" class="apv-form" v-for="f in g.items" :key="f.id"
                      :class="{ 'is-active': f.id == localApproveFormCode }" :title="f.text"
                      @click="localApproveFormCode = f.id">
                <span class="apv-form__radio"></span>
                <span class="apv-form__name">{{ f.sub }}</span>
                <i class="fas fa-check apv-form__tick" v-if="f.id == localApproveFormCode"></i>
              </button>
            </div>
            <div class="apv-forms__empty" v-if="!formGroups.length">
              <i class="fas fa-search"></i> {{ ui.erp_no_data || 'ไม่มีข้อมูล' }}
            </div>
          </div>
        </template>
        </section>

        <section class="apv-pane apv-pane--chain">
        <div class="apv-step">
          <span class="apv-step__no">2</span>
          <span class="apv-step__label">{{ ui.erp_approver || 'ผู้อนุมัติ' }}</span>
          <span class="apv-count" v-if="approverList.length">
            {{ approverList.length }} {{ ui.erp_item || 'รายการ' }}
          </span>
        </div>

        <ol class="apv-chain" v-if="approverList.length">
          <li class="apv-node" v-for="(x, idx) in approverList" :key="idx"
              :class="'apv-node--' + levelTone(x.levelapp)" :style="{ '--i': idx }">
            <div class="apv-node__rail">
              <span class="apv-node__seq">{{ x.itemno }}</span>
            </div>
            <div class="apv-node__card">
              <span class="apv-node__avatar"><i class="fas fa-user"></i></span>
              <div class="apv-node__main">
                <div class="apv-node__name">{{ x.empfullname_t || '-' }}</div>
                <div class="apv-node__meta">
                  <span class="apv-tag apv-tag--pos" v-if="x.fr_proj_type">
                    <i class="fas fa-id-badge"></i> {{ x.fr_proj_type }}
                  </span>
                  <span class="apv-tag" :class="'apv-lv--' + levelTone(x.levelapp)" v-if="x.levelapp">
                    <i :class="levelIcon(x.levelapp)"></i> {{ x.levelapp }}
                  </span>
                </div>
              </div>
            </div>
          </li>
        </ol>
        <div class="apv-empty" v-else>
          <i class="far fa-address-book"></i>
          <span v-if="xt.isEmpty(localApproveFormCode)">กรุณาเลือก Form Approve เพื่อแสดงรายชื่อผู้อนุมัติ</span>
          <span v-else>{{ ui.erp_no_data || 'ไม่มีข้อมูล' }}</span>
        </div>

        <div class="apv-callout">
          <span class="apv-callout__ico"><i class="fas fa-exclamation-triangle"></i></span>
          <div class="apv-callout__text">
            <strong>{{ ui.erp_remark || 'หมายเหตุ' }} :</strong>
            กรุณาตรวจสอบรายชื่อของผู้อนุมัติ ก่อนทำการกด Submit
          </div>
        </div>
        </section>
      </div>
    </template>
    <template #footer>
      <div class="apv-foot">
        <button type="button" class="btn btn-sm btn-default apv-btn apv-btn--close" @click="closeApproveModal()">
          <i class="fas fa-times"></i> {{ ui.csm_v2_close_window || 'ปิดหน้าต่าง' }}
        </button>
        <button type="button" class="btn btn-sm btn-success apv-btn apv-btn--submit" @click="confirmApprove()">
          <i class="fas fa-paper-plane"></i> {{ ui.erp_submit_approval || 'ยืนยันการส่งอนุมัติ' }}
        </button>
      </div>
    </template>
  </modal>
</template>

<script type="text/javascript">
  export default {
    props: {
      approveFormOptions: Array,
      approveFormCode: String,
      approveDetailData: Array,
      loadFormDetail: Function,
      closeApproveModal: Function,
      confirmApprove: Function,
      isMango: Boolean,
    },
    data() {
      return {
        ui: window.ui,
        xt: $xt,
        localApproveFormCode: this.approveFormCode,
        formSearch: '',
      }
    },
    computed: {
      formGroups() {
        let q = this.formSearch.trim().toLowerCase()
        let groups = []
        for (const x of (this.approveFormOptions || [])) {
          let text = x.text || ''
          if (q && !text.toLowerCase().includes(q) && !String(x.id).toLowerCase().includes(q)) continue
          let i = text.indexOf(':')
          let name = i > -1 ? text.slice(0, i).trim() : text.trim()
          let sub = i > -1 ? text.slice(i + 1).trim() : text.trim()
          let g = groups.find(y => y.name === name)
          if (!g) groups.push(g = { name, items: [] })
          g.items.push({ id: x.id, text, sub: sub || text })
        }
        return groups
      },
      approverList() {
        return (this.approveDetailData || []).slice().sort((a, b) => ($xt.int(a.itemno) - $xt.int(b.itemno)))
      },
      selectedFormName() {
        let hit = (this.approveFormOptions || []).find(x => x.id == this.localApproveFormCode)
        return hit ? hit.text : ''
      },
    },
    watch: {
      approveFormCode(val) {
        this.localApproveFormCode = val
      },
      localApproveFormCode(val) {
        this.$emit('update:approveFormCode', val)
        this.loadFormDetail()
      },
    },
    methods: {
      levelTone(name) {
        return {
          'Upper Authorized': 'authorized',
          'Upper Approve': 'upper',
          'Review': 'review',
          'Last Approve': 'last',
          'Sequence Approve': 'sequence',
        }[name] || 'default'
      },
      levelIcon(name) {
        return {
          'Upper Authorized': 'fas fa-crown',
          'Upper Approve': 'fas fa-angle-double-up',
          'Review': 'fas fa-search',
          'Last Approve': 'fas fa-flag-checkered',
          'Sequence Approve': 'fas fa-stream',
        }[name] || 'fas fa-layer-group'
      },
      openModal() {
        this.formSearch = ''
        this.$refs.approveModal.openModal()
      },
      closeModal() {
        this.$refs.approveModal.closeModal()
      },
      setSize(size) {
        this.$refs.approveModal.setSize(size)
      },
    },
  }
</script>

<style scoped>
  .apv-head {
    display: flex;
    align-items: center;
    gap: 11px;
    min-width: 0;
  }
  .apv-head__ico {
    width: 36px;
    height: 36px;
    flex: 0 0 36px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border-radius: 10px;
    background: rgba(255,255,255,.16);
    box-shadow: inset 0 0 0 1px rgba(255,255,255,.18);
    font-size: 15px;
  }
  .apv-head__text { min-width: 0; }
  .apv-head__title {
    margin: 0;
    font-size: 15px;
    font-weight: 700;
    letter-spacing: -.01em;
  }
  .apv-head__sub {
    margin-top: 2px;
    font-size: 11.5px;
    font-weight: 500;
    color: rgba(255,255,255,.72);
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .apv { padding: 2px 0; }

  .apv-step {
    display: flex;
    align-items: center;
    gap: 9px;
    margin-bottom: 9px;
  }
  .apv-step__no {
    width: 22px;
    height: 22px;
    flex: 0 0 22px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    background: linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%);
    color: #fff;
    font-size: 11px;
    font-weight: 700;
    box-shadow: 0 5px 12px -6px #1d4ed8;
  }
  .apv-step__label {
    flex: 1 1 auto;
    min-width: 0;
    font-size: 13px;
    font-weight: 700;
    color: #1f2c40;
    letter-spacing: -.01em;
  }
  .apv-req { color: #e74c3c; }
  .apv-count {
    flex: 0 0 auto;
    padding: 3px 11px;
    border-radius: 999px;
    background: #eef2fb;
    border: 1px solid #dfe6f5;
    font-size: 11px;
    font-weight: 700;
    color: #43536e;
    font-variant-numeric: tabular-nums;
  }

  .apv-field { margin-bottom: 20px; }

  .apv-chain {
    list-style: none;
    margin: 0 0 18px;
    padding: 0;
  }
  .apv-node {
    --apv-n1: #94a3b8;
    --apv-n2: #475569;
    --apv-nt: rgba(100,116,139,.07);
    display: flex;
    gap: 12px;
    animation: apvIn .3s cubic-bezier(.22,.9,.3,1) both;
    animation-delay: calc(var(--i, 0) * 55ms);
  }
  .apv-node--authorized { --apv-n1: #fbbf24; --apv-n2: #b45309; --apv-nt: rgba(245,158,11,.10); }
  .apv-node--upper      { --apv-n1: #a78bfa; --apv-n2: #6d28d9; --apv-nt: rgba(139,92,246,.09); }
  .apv-node--review     { --apv-n1: #22d3ee; --apv-n2: #0e7490; --apv-nt: rgba(6,182,212,.10); }
  .apv-node--last       { --apv-n1: #34d399; --apv-n2: #047857; --apv-nt: rgba(16,185,129,.10); }
  .apv-node--sequence   { --apv-n1: #60a5fa; --apv-n2: #1d4ed8; --apv-nt: rgba(59,130,246,.09); }
  .apv-node__rail {
    position: relative;
    flex: 0 0 30px;
    display: flex;
    justify-content: center;
  }
  .apv-node__rail::before {
    content: "";
    position: absolute;
    top: 30px;
    bottom: 0;
    left: 50%;
    width: 2px;
    margin-left: -1px;
    border-radius: 2px;
    background: linear-gradient(180deg, var(--apv-n1) 0%, #e6ecf7 100%);
    opacity: .6;
  }
  .apv-node:last-child .apv-node__rail::before { display: none; }
  .apv-node__seq {
    position: relative;
    z-index: 1;
    width: 30px;
    height: 30px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    background: linear-gradient(140deg, var(--apv-n1) 0%, var(--apv-n2) 100%);
    color: #fff;
    font-size: 12px;
    font-weight: 700;
    font-variant-numeric: tabular-nums;
    box-shadow: 0 0 0 4px #fff, 0 7px 15px -8px var(--apv-n2), inset 0 1px 0 rgba(255,255,255,.35);
  }

  .apv-node__card {
    flex: 1 1 auto;
    min-width: 0;
    display: flex;
    align-items: center;
    gap: 11px;
    margin-bottom: 10px;
    padding: 11px 14px;
    border: 1px solid #e8edf6;
    border-left: 3px solid var(--apv-n1);
    border-radius: 5px 12px 12px 5px;
    background: linear-gradient(120deg, var(--apv-nt) 0%, rgba(255,255,255,0) 68%);
    transition: transform .2s ease, box-shadow .2s ease, border-color .2s ease;
  }
  .apv-node__card:hover {
    transform: translateX(3px);
    border-color: #d8e2f3;
    border-left-color: var(--apv-n2);
    box-shadow: 0 10px 24px -18px rgba(15,23,42,.6);
  }
  .apv-node__avatar {
    width: 34px;
    height: 34px;
    flex: 0 0 34px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    background: #fff;
    color: var(--apv-n2);
    font-size: 13px;
    box-shadow: inset 0 0 0 1px var(--apv-n1);
  }
  .apv-node__main { min-width: 0; }
  .apv-node__name {
    font-size: 13.5px;
    font-weight: 600;
    color: #16233a;
    line-height: 1.35;
    word-break: break-word;
  }
  .apv-node__meta {
    display: flex;
    align-items: center;
    gap: 6px;
    flex-wrap: wrap;
    margin-top: 5px;
  }
  .apv-tag {
    display: inline-flex;
    align-items: center;
    gap: 5px;
    padding: 2px 9px;
    border-radius: 999px;
    font-size: 11px;
    font-weight: 600;
  }
  .apv-tag > i { font-size: 9px; opacity: .85; }
  .apv-tag--pos {
    background: #eff3fa;
    border: 1px solid #e1e8f4;
    color: #4d5f7c;
  }

  .apv-lv--authorized {
    background: linear-gradient(135deg, #fef3c7 0%, #fde68a 100%);
    border: 1px solid #fcd34d;
    color: #92400e;
  }
  .apv-lv--upper {
    background: linear-gradient(135deg, #ede9fe 0%, #ddd6fe 100%);
    border: 1px solid #c4b5fd;
    color: #5b21b6;
  }
  .apv-lv--review {
    background: linear-gradient(135deg, #cffafe 0%, #a5f3fc 100%);
    border: 1px solid #67e8f9;
    color: #0e7490;
  }
  .apv-lv--last {
    background: linear-gradient(135deg, #dcfce7 0%, #bbf7d0 100%);
    border: 1px solid #86efac;
    color: #166534;
  }
  .apv-lv--sequence {
    background: linear-gradient(135deg, #dbeafe 0%, #bfdbfe 100%);
    border: 1px solid #93c5fd;
    color: #1e40af;
  }
  .apv-lv--default {
    background: #f1f5f9;
    border: 1px solid #e2e8f0;
    color: #475569;
  }

  .apv-empty {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 11px;
    margin-bottom: 18px;
    padding: 34px 16px;
    border: 1px dashed #dde4f0;
    border-radius: 12px;
    background: #fbfcfe;
    color: #93a0b5;
    font-size: 12.5px;
    font-weight: 600;
    text-align: center;
  }
  .apv-empty > i {
    width: 54px;
    height: 54px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    background: #eef2fa;
    font-size: 22px;
    color: #a7b4ca;
  }

  .apv-callout {
    display: flex;
    align-items: flex-start;
    gap: 11px;
    padding: 11px 14px;
    border: 1px solid #fde9b8;
    border-left: 4px solid #f5a623;
    border-radius: 10px;
    background: linear-gradient(120deg, #fffaef 0%, #fffdf8 100%);
  }
  .apv-callout__ico {
    flex: 0 0 auto;
    margin-top: 1px;
    color: #e08c0b;
    font-size: 15px;
  }
  .apv-callout__text {
    font-size: 12px;
    line-height: 1.6;
    color: #7a611a;
  }
  .apv-callout__text > strong { color: #6b5312; }

  .apv-foot {
    display: flex;
    justify-content: flex-end;
    gap: 8px;
    width: 100%;
  }
  .apv-btn {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    border-radius: 8px;
    font-weight: 600;
    transition: transform .15s ease, box-shadow .2s ease;
  }
  .apv-btn:active { transform: translateY(1px); }
  .apv-btn--close {
    padding: 7px 16px;
    border: 1px solid #dce4ec;
  }
  .apv-btn--submit {
    padding: 7px 18px;
    border-color: transparent;
    background: linear-gradient(135deg, #22c55e 0%, #15803d 100%);
    box-shadow: 0 6px 16px -8px rgba(21,128,61,.85);
  }
  .apv-btn--submit:hover,
  .apv-btn--submit:focus {
    background: linear-gradient(135deg, #16a34a 0%, #166534 100%);
    box-shadow: 0 8px 20px -8px rgba(21,128,61,.9);
  }

  .apv--split {
    display: grid;
    grid-template-columns: minmax(320px, 460px) minmax(0, 1fr);
    gap: 24px;
    align-items: start;
  }
  .apv--split .apv-pane--forms {
    display: flex;
    flex-direction: column;
    min-width: 0;
    padding: 16px;
    border: 1px solid #e6ecf5;
    border-radius: 14px;
    background: #f8fafd;
  }
  .apv--split .apv-pane--chain { min-width: 0; padding-top: 16px; }
  .apv--split .apv-step { margin-bottom: 12px; }
  .apv--split .apv-step__no { width: 26px; height: 26px; flex-basis: 26px; font-size: 12.5px; }
  .apv--split .apv-step__label { font-size: 15px; }
  .apv--split .apv-count { font-size: 12px; padding: 3px 12px; }
  .apv--split .apv-search { margin-bottom: 12px; }
  .apv--split .apv-search > .fa-search { left: 13px; font-size: 14px; }
  .apv--split .apv-search__input { height: 42px; padding: 0 34px 0 38px; border-radius: 10px; font-size: 14.5px; }
  .apv--split .apv-search__clear { right: 12px; font-size: 14px; }
  .apv--split .apv-forms { max-height: min(62vh, 600px); }
  .apv--split .apv-group + .apv-group { margin-top: 14px; }
  .apv--split .apv-group__title { padding: 5px 4px 7px; font-size: 12px; }
  .apv--split .apv-group__n { font-size: 11.5px; padding: 1px 8px; }
  .apv--split .apv-form { gap: 12px; margin-bottom: 7px; padding: 12px 14px; border-radius: 10px; font-size: 14.5px; }
  .apv--split .apv-form__radio { flex-basis: 18px; width: 18px; height: 18px; }
  .apv--split .apv-form.is-active .apv-form__radio { box-shadow: inset 0 0 0 3px #fff, inset 0 0 0 9px #1d4ed8; }
  .apv--split .apv-form__tick { font-size: 14px; }
  .apv--split .apv-forms__empty { font-size: 14px; }
  .apv--split .apv-node { gap: 14px; }
  .apv--split .apv-node__rail { flex-basis: 36px; }
  .apv--split .apv-node__seq { width: 36px; height: 36px; font-size: 14px; }
  .apv--split .apv-node__rail::before { top: 36px; }
  .apv--split .apv-node__card { gap: 14px; margin-bottom: 12px; padding: 14px 18px; }
  .apv--split .apv-node__avatar { width: 42px; height: 42px; flex-basis: 42px; font-size: 16px; }
  .apv--split .apv-node__name { font-size: 15.5px; }
  .apv--split .apv-tag { font-size: 12.5px; padding: 3px 11px; }
  .apv--split .apv-tag > i { font-size: 10.5px; }
  .apv--split .apv-empty { padding: 48px 16px; font-size: 14px; }
  .apv--split .apv-empty > i { width: 64px; height: 64px; font-size: 26px; }
  .apv--split .apv-callout { padding: 13px 16px; }
  .apv--split .apv-callout__text { font-size: 13.5px; }

  .apv-search {
    position: relative;
    margin-bottom: 10px;
  }
  .apv-search > .fa-search {
    position: absolute;
    top: 50%;
    left: 11px;
    transform: translateY(-50%);
    padding: 0 !important;
    font-size: 12px;
    color: #94a3b8;
  }
  .apv-search__input {
    width: 100%;
    height: 34px;
    padding: 0 30px 0 32px;
    border: 1px solid #d9e1ee;
    border-radius: 8px;
    background: #fff;
    font-size: 13px;
    color: #1f2c40;
    outline: none;
    transition: border-color .15s ease, box-shadow .15s ease;
  }
  .apv-search__input:focus {
    border-color: #3b82f6;
    box-shadow: 0 0 0 3px rgba(59,130,246,.15);
  }
  .apv-search__clear {
    position: absolute;
    top: 50%;
    right: 9px;
    transform: translateY(-50%);
    color: #94a3b8;
    font-size: 12px;
  }
  .apv-search__clear:hover { color: #475569; }
  .apv-search__clear > i { padding: 0 !important; }

  .apv-forms {
    max-height: min(52vh, 440px);
    overflow-y: auto;
    margin: 0 -4px;
    padding: 0 4px;
  }
  .apv-group + .apv-group { margin-top: 10px; }
  .apv-group__title {
    position: sticky;
    top: 0;
    z-index: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
    padding: 4px 4px 5px;
    background: #f8fafd;
    font-size: 11px;
    font-weight: 700;
    letter-spacing: .02em;
    text-transform: uppercase;
    color: #64748b;
  }
  .apv-group__n {
    padding: 0 7px;
    border-radius: 999px;
    background: #e8eef8;
    font-size: 10.5px;
    color: #475569;
  }
  .apv-form {
    display: flex;
    align-items: center;
    gap: 10px;
    width: 100%;
    margin-bottom: 5px;
    padding: 8px 11px;
    border: 1px solid #e3e9f3;
    border-radius: 8px;
    background: #fff;
    text-align: left;
    font-size: 13px;
    color: #1f2c40;
    cursor: pointer;
    transition: border-color .15s ease, background .15s ease, box-shadow .15s ease;
  }
  .apv-form:hover { border-color: #bcd0f0; background: #f5f9ff; }
  .apv-form:focus { outline: none; box-shadow: 0 0 0 3px rgba(59,130,246,.15); }
  .apv-form__radio {
    flex: 0 0 16px;
    width: 16px;
    height: 16px;
    border: 2px solid #c3cfe0;
    border-radius: 50%;
    background: #fff;
    transition: border-color .15s ease, box-shadow .15s ease;
  }
  .apv-form__name {
    flex: 1 1 auto;
    min-width: 0;
    line-height: 1.4;
    word-break: break-word;
  }
  .apv-form__tick { padding: 0 !important; font-size: 12px; color: #1d4ed8; }
  .apv-form.is-active {
    border-color: #3b82f6;
    background: linear-gradient(120deg, #eaf2ff 0%, #f7faff 100%);
    box-shadow: 0 6px 16px -12px rgba(29,78,216,.7);
    font-weight: 600;
    color: #1e3a8a;
  }
  .apv-form.is-active .apv-form__radio {
    border-color: #1d4ed8;
    box-shadow: inset 0 0 0 3px #fff, inset 0 0 0 8px #1d4ed8;
  }
  .apv-forms__empty {
    padding: 24px 8px;
    text-align: center;
    font-size: 12.5px;
    font-weight: 600;
    color: #94a3b8;
  }
  .apv-forms__empty > i { padding: 0 !important; margin-right: 4px; }

  @keyframes apvIn {
    from { opacity: 0; transform: translateY(6px); }
    to { opacity: 1; transform: none; }
  }

  @media (max-width: 767px) {
    .apv--split { grid-template-columns: minmax(0, 1fr); gap: 14px; }
    .apv--split .apv-pane--chain { padding-top: 0; }
    .apv--split .apv-forms { max-height: 38vh; }
  }
  @media (max-width: 639px) {
    .apv-head__sub { display: none; }
    .apv-node { gap: 9px; }
    .apv-node__rail { flex: 0 0 26px; }
    .apv-node__seq { width: 26px; height: 26px; font-size: 11px; }
    .apv-node__rail::before { top: 26px; }
    .apv-node__card { padding: 10px 12px; gap: 9px; }
    .apv-node__avatar { width: 30px; height: 30px; flex: 0 0 30px; font-size: 12px; }
    .apv-foot { flex-direction: column-reverse; }
    .apv-foot .apv-btn { justify-content: center; width: 100%; }
  }
  @media (prefers-reduced-motion: reduce) {
    .apv-node { animation: none; }
    .apv-node__card,
    .apv-form,
    .apv-btn { transition: none; }
  }
</style>
